<template>
	<div class="teamMember" v-on:click="showMoreInfo()">
		<div class="teamMemberImg">
			<img :alt="memberName" class="fillImg" v-if="picture!=''" :src="picture"/>
		</div>
		<h4><strong>{{memberName}}</strong>, {{title}}</h4>
		<span class="memberReadMore" v-if="info!=''">קראו עוד></span>
	</div>
</template>

<script>
  export default {
    components: {
    },
	props: ['parentComp','memberName','title','info','picture','song'],
	created () {
	},
	data() {
		return {
			showInfo : false
		}
	},
	methods: {
		showMoreInfo() {
			if (this.info && this.info != '') {
				console.log(this.parentComp);
				this.parentComp.$options.methods.showTeamMemberInfo(this.parentComp,this.memberName,this.title,this.info,this.picture,this.song);
			}
		}
	}
	
  }
</script>


// WEBPACK FOOTER //
// TeamMember.vue?9741a188